<template>
    <el-dialog class="editor-dialog" :title="model.name" append-to-body :visible.sync="visible" :show-close="false" width="80%" top="3vh">
      <el-tabs type="border-card"  class="my-content">
        <el-tab-pane label="基本信息">
          <el-descriptions class="desciption" title="基本信息" direction="vertical" :column="4" border>
            <el-descriptions-item labelClassName='label-style'>
              <template slot="label">
                供应商编号
              </template>
              <span class="content">{{ "SP"+ String(model.seq).padStart(5, '0') }}</span>
            </el-descriptions-item>
            <el-descriptions-item labelClassName='label-style'>
              <template slot="label">
                供应商等级
              </template>
              <el-rate v-model="model.rate" text-color="#ff9900"></el-rate>
            </el-descriptions-item>
            <el-descriptions-item labelClassName='label-style'>
              <template slot="label">
                供应商标签
              </template>           
              <div>
                <el-tag v-for="item in model.tags" :key="item" type="danger" plain style="margin: 2px;">{{ item }}</el-tag>              
              </div>
            </el-descriptions-item>
            <el-descriptions-item labelClassName='label-style'>
              <template slot="label">
                供应商地址
              </template>
              <span class="content">{{ model.contactAdd }}</span>
            </el-descriptions-item>
            <el-descriptions-item labelClassName='label-style'>
              <template slot="label">
                供应商电话
              </template>
              <span class="content">{{ model.contactPhone }}</span>
            </el-descriptions-item>
            <el-descriptions-item labelClassName='label-style'>
              <template slot="label">
                供应商邮箱
              </template>
              <span style="cursor: pointer;">{{ model.email }}</span>
            </el-descriptions-item>    
            <el-descriptions-item labelClassName='label-style'>
              <template slot="label">
                供应商官网 
              </template>
              <span plain @click="openWebsite(model.website)" style="cursor: pointer">{{ model.website }}</span>    
            </el-descriptions-item>
            <el-descriptions-item labelClassName='label-style'>
              <template slot="label">
                附件
              </template>
              <div style="display:flex;flex-flow:row wrap;justify-content:start;">
                <div v-for="(file,index) in model.attachments" :key="index" style="position: relative;margin:3px">
                  <el-tooltip class="item" effect="dark" :content="file.filename" placement="top">
                    <el-image class="image" v-if="['.pdf','.PDF'].includes(file.filename.substring(file.filename.lastIndexOf('.')))" :src="require('@/assets/images/format/pdf.png')" fit="cover" @click="previewAttachment(file.path,file.filename,'pdf')"></el-image>
                    <el-image class="image" v-if="['.xls','.xlsx','.XLS','.XLSX'].includes(file.filename.substring(file.filename.lastIndexOf('.')))" :src="require('@/assets/images/format/xlsx.png')" fit="cover" @click="previewAttachment(file.path,file.filename,'excel')"></el-image>
                    <el-image class="image" v-if="['.doc','.docx','.DOC','.DOCX'].includes(file.filename.substring(file.filename.lastIndexOf('.')))" :src="require('@/assets/images/format/docx.png')" fit="cover" @click="previewAttachment(file.path,file.filename,'word')"></el-image>
                    <el-image class="image" v-if="['.ppt','.pptx','.PPT','.PPTX'].includes(file.filename.substring(file.filename.lastIndexOf('.')))" :src="require('@/assets/images/format/pptx.png')" fit="cover" @click="previewAttachment(file.path,file.filename,'ppt')"></el-image>
                    <el-image class="image" v-if="['.avi','.mpg','.mpeg','.wmv','.mpeg-4','.rmvb','.mkv','.flv','.mov','.mp4','.3gp'].includes(file.filename.substring(file.filename.lastIndexOf('.')))" :src="require('@/assets/images/format/video.png')" fit="cover" @click="previewAttachment(file.path,file.filename,'video')"></el-image>
                    <el-image class="image" v-if="['.jpg','.jpeg','.png','.bmp','.gif','.tiff','.JPG','.JPEG','.PNG','.BMP','.GIF'].includes(file.filename.substring(file.filename.lastIndexOf('.')))" :src="require('@/assets/images/format/jpeg.png')" fit="cover" @click="previewAttachment(file.path,file.filename,'image')"></el-image>
                    <el-image class="image" v-else :src="require('@/assets/images/format/other.png')" fit="cover" @click="previewAttachment(file.path,file.filename,'other')"></el-image>
                  </el-tooltip>
                </div>
              </div>
            </el-descriptions-item>
            <el-descriptions-item labelClassName='label-style'>
              <template slot="label">
                业务范围
              </template>
              <span class="content">{{ model.businessScope }}</span>
            </el-descriptions-item>
          </el-descriptions>
        </el-tab-pane>
        <el-tab-pane label="财务信息">
          <el-descriptions class="desciption" title="基本信息" direction="vertical" :column="4" border>
            <el-descriptions-item labelClassName='label-style'>
              <template slot="label">
                发票抬头
              </template>
              <span class="content">{{ model.name }}</span>
            </el-descriptions-item>          
            <el-descriptions-item labelClassName='label-style'>
              <template slot="label">
                发票税号
              </template>
              <span class="content">{{ model.financialInfo.taxNumber }}</span>
            </el-descriptions-item>
            <el-descriptions-item labelClassName='label-style'>
              <template slot="label">
                开户行名称
              </template>
              <span class="content">{{ model.financialInfo.bankName }}</span>
            </el-descriptions-item>
            <el-descriptions-item labelClassName='label-style'>
              <template slot="label">
                开户行账号
              </template>
              <span class="content">{{ model.financialInfo.accountNumber }}</span>
            </el-descriptions-item>
            <el-descriptions-item labelClassName='label-style'>
              <template slot="label">
                开户行地址
              </template>
              <span class="content">{{ model.financialInfo.bankAddress }}</span>
            </el-descriptions-item>
            <el-descriptions-item labelClassName='label-style'>
              <template slot="label">
                SWIFT CODE
              </template>
              <span class="content">{{ model.financialInfo.SWIFTCode }}</span>
            </el-descriptions-item>          
            <el-descriptions-item labelClassName='label-style' :span="1">
              <template slot="label">
                开票电话
              </template>
              <span class="content">{{ model.financialInfo.phone }}</span>
            </el-descriptions-item>
            <el-descriptions-item labelClassName='label-style' :span="1">
              <template slot="label">
                注册地址
              </template>
              <span class="content">{{ model.financialInfo.address }}</span>
            </el-descriptions-item>
          </el-descriptions>
        </el-tab-pane>
        <el-tab-pane label="联系人">
          <el-table :data="model.contact" header-align="center" size="small" highlight-current-row :cell-style="{padding:'5px',fontSize:'13px',borderColor:'#ddd'}" ref="multipleTable" id="TableOutPut" :row-style="{height:'45px'}" border stripe :header-cell-style="headerStyle">
            <el-table-column  prop="name" label="姓名" align="center" min-width="80"></el-table-column>
            <el-table-column  prop="department" label="部门" align="center" min-width="80"></el-table-column>
            <el-table-column  prop="position" label="职位" align="center" min-width="80"></el-table-column>
            <el-table-column  prop="phone" label="电话" align="center" min-width="80"></el-table-column>
            <el-table-column  prop="email" label="邮箱" align="center" min-width="120"></el-table-column>
            <el-table-column  prop="address" label="地址" align="center" min-width="120"></el-table-column>
            <el-table-column  prop="remark" label="备注" align="center" min-width="100"></el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </template>
  <script>
  import http from '@/http'
  export default {
  data() {
    return {
      visible: false,
      supplierId:'',
      model:{contact:[],financialInfo:{}}
    };
  },
  methods:{
    async fetchSupplier() {
      const res = await http.get(`purchase/supplier/id/${this.supplierId}`);    
      this.model = res.data
    },
    openWebsite(website){
      window.open(website,'_blank')
    },
    async previewAttachment(path,filename,type){
      const res= await http.get('/oss/signatureUrl',{params:{url:path}})  
      this.attachmentViewer(res.data,filename,type,()=>{})  
    }, 
  },
  created(){
    this.fetchSupplier()
  }
  };
  </script>
  <style scoped>
  .editor-dialog>>>.el-dialog__header {
    text-align: center !important;
    padding:15px 5px 5px 5px;
  }
  .editor-dialog>>>.el-dialog__body {
    padding:20px 10px;
  }
  .editor-dialog>>>.el-dialog__title {
    font-weight: 700 !important;
  }
  .editor-dialog>>>.el-textarea__inner{
    font-family: Arial, Helvetica, sans-serif;
  }
  .editor-dialog>>>.el-descriptions__header{
    display: none;
  }
  .image{
    height: 40px;
    width: 40px;
    margin: auto;
    cursor: pointer;
  }
  .content{
    display:inline-block;
    height:15px!important;
    padding: 0;
  }
  </style>
  